import React from 'react';
import styled from 'styled-components';

const TidalDashboardWebhookOrderHistoryWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;

const TidalDashboardWebhookOrderHistoryTitle = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.colors.text[1]};
  margin-bottom: 15px;
`;

const TidalDashboardWebhookOrderHistoryContainer = styled.table`
  text-align: right;
  position: relative;
  width: 100%;
  border: 0;
  border-collapse: separate;
  border-spacing: 0;

  tr,
  td {
    padding: 10px 5px;
    border-spacing: 0;
  }
  th {
    padding: 10px 5px;
  }

  & > thead > tr > th {
    font-weight: 600;
    font-size: 14px;
    line-height: 32px;
    color: ${(props) => props.theme.colors.text[0]};
    position: sticky;
    top: 0;
    background-color: ${(props) => props.theme.colors.background};
    border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
    border-collapse: separate;
  }

  & > thead > tr > th:nth-child(1) {
    text-align: left;
  }

  & > thead > tr > th:nth-child(2) {
    text-align: left;
  }

  & > tbody > tr > td {
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: ${(props) => props.theme.colors.text[1]};
  }

  & > tbody > tr:nth-child(even) {
    background-color: ${(props) => props.theme.colors.primary};
    td {
      border-top: 1px solid ${(props) => props.theme.colors.borderColors[1]};
      border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
    }
  }

  & > tbody > tr > td:nth-child(1) {
    text-align: left;
  }

  & > tbody > tr > td:nth-child(2) {
    text-align: left;
  }

  & > tbody > tr > td:nth-child(5) {
    color: ${(props) => props.theme.colors.accent};
  }
`;

interface TidalDashboardWebhookOrderHistoryProps {
  columns: string[];
  data: any;
  label: string;
}

const TidalDashboardWebhookOrderHistory = ({
  columns,
  data,
  label,
}: TidalDashboardWebhookOrderHistoryProps): JSX.Element => {
  return (
    <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
      <TidalDashboardWebhookOrderHistoryTitle>
        {label}
      </TidalDashboardWebhookOrderHistoryTitle>
      <TidalDashboardWebhookOrderHistoryWrapper>
        <TidalDashboardWebhookOrderHistoryContainer>
          <thead>
            <tr>
              {columns.map((column: string, key: number) => {
                return <th key={key}>{column}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {data &&
              typeof data &&
              data?.userPayloads.map((row: any, key: number) => {
                return (
                  <tr key={key}>
                    <td>{row.site}</td>
                    <td>{row.product}</td>
                    <td>{row.size}</td>
                    <td>{row.email.length > 0 ? row.email : 'N/A'}</td>
                    <td>#{row.order}</td>
                  </tr>
                );
              })}
          </tbody>
        </TidalDashboardWebhookOrderHistoryContainer>
      </TidalDashboardWebhookOrderHistoryWrapper>
    </div>
  );
};

export default TidalDashboardWebhookOrderHistory;
